import { render, staticRenderFns } from "./DocumentAgentDetail.vue?vue&type=template&id=2d9689f2&scoped=true&lang=pug"
import script from "./DocumentAgentDetail.vue?vue&type=script&lang=js"
export * from "./DocumentAgentDetail.vue?vue&type=script&lang=js"
import style0 from "./DocumentAgentDetail.vue?vue&type=style&index=0&id=2d9689f2&prod&scoped=true&lang=css"
import style1 from "./DocumentAgentDetail.vue?vue&type=style&index=1&id=2d9689f2&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d9689f2",
  null
  
)

export default component.exports